import React, { useContext } from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import NotFoundPage from 'pages/NotFoundPage';
import HomePage from 'pages/HomePage';
import { AuthContext } from 'context/auth';
import FailedLoginPage from 'pages/FailedLoginPage';
import { MCFFormsProvider } from 'context/mcfforms';
import UpdateSubmissionForm from 'pages/UpdateSubmissionForm';
import UpdateApprovedSubmissionForm from 'pages/UpdateApprovedSubmissionForm';
import SubmitForRerun from 'pages/SubmitForRerun';
import FileNameGenerator from 'pages/FileNameGenerator';
import RejectForm from 'pages/RejectForm';
import RejectReviewForm from 'pages/RejectReviewForm';

function App() {
    const { user } = useContext(AuthContext);

    return user === null ? null : user === 'NoUser' ? (
        <ChakraProvider>
            <Router>
                <Navbar />
                <Routes>
                    <Route path='/' element={<HomePage />} />
                    <Route path='/failedLogin' element={<FailedLoginPage />} />
                    <Route path='*' element={<Navigate replace to='/' />} />
                </Routes>
            </Router>
        </ChakraProvider>
    ) : (
        <ChakraProvider theme={theme}>
            <Router>
                <MCFFormsProvider>
                    <Navbar />
                    <Routes>
                        <Route path='/' element={<HomePage />} />
                        <Route path='/editForm/:objectId' element={<UpdateSubmissionForm />} />
                        <Route path='/editApprovedForm/:objectId' element={<UpdateApprovedSubmissionForm />} />
                        <Route path='/submitForRerun/:objectId' element={<SubmitForRerun />} />
                        <Route path='/rejectForm/:objectId' element={<RejectForm />} />
                        <Route path='/rejectReviewForm/:objectId' element={<RejectReviewForm />} />
                        <Route path='/fileNameGenerator' element={<FileNameGenerator />} />
                        <Route path='*' element={<NotFoundPage />} />
                    </Routes>
                </MCFFormsProvider>
            </Router>
        </ChakraProvider>
    );
}

export default App;
